<template>
  <!-- Modal -->
  <div class="modal fade" data-backdrop="static" id="listCollectiomModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Switch Collection</h5>
          <button type="button" class="close" @click="cancelModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">

          <ul class="list-group">
            

            <li v-for="collection in collections" :key="collection.collId" class="list-group-item d-flex align-items-center">
              <button type="button" class="btn btn-light mr-2" @click="updateCollectionName(collection.collId, collection.collName)"><font-awesome-icon icon="edit" /></button>
              <button type="button" class="btn btn-light mr-2" @click="deleteCollection(collection.collId)" ><font-awesome-icon icon="trash" /></button>
              <button type="button" class="btn btn-dark flex-fill" @click="switchCollection(collection.collId)">{{collection.collName}}</button>
            </li>


            <li class="list-group-item d-flex align-items-center">
              <button type="button" class="btn btn-primary flex-fill" @click="addNewCollection"><font-awesome-icon icon="edit" />&nbsp; Add new Collection</button>
            </li>
          </ul>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="cancelModal">OK</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import $ from 'jquery'

export default {
  name: 'ListCollectionModal',
  props: ['collName', 'showListCollectionModal', "collections"],
  watch: {
    showListCollectionModal: function(newVal) {
      if (newVal) {
        $('#listCollectiomModal').modal('show')
      } else {
        $('#listCollectiomModal').modal('hide')
      }

    }
  },
  methods: {
    cancelModal: function(){
      this.$emit("cancelListCollectionModal")
    },
    addNewCollection: function(){
      this.$emit("saveAddCollection")
    },
    switchCollection: function(collId){
      this.$emit("switchCollection", collId)
      this.$emit("cancelListCollectionModal")
    },
    deleteCollection: function(collId){
      this.$emit("deleteCollection", collId)
    },
    updateCollectionName: function(collId, collName){
      this.$emit("updateCollectionName", collId, collName)
    }
  },
  mounted: function(){
  }
}
</script>
